import { createAuthStore } from '@ficpod/api-client'

export const useAuthStore = createAuthStore('ficpod-auth')
